export default "/assets/images/smog-video-thumbnail.jpg?4f95c37931e6b93c4e6de28591e198f6";